import * as React from 'react';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './LoginPage.css';
import { apiRequest } from '../api/client';
import OAuthButton from '../components/OAuthButton';
import config from '../config';
import OrDivider from '../components/OrDivider';

type LoginResponse = {
  token: string;
  user: {
    name: string;
    email: string;
  };
};

const LoginPage: React.FC = () => {
  React.useEffect(() => { // Check if user is already logged in
    const token = localStorage.getItem('authToken');
    if (token) {
      navigate('/dashboard');
    }
  }, []);
  const navigate = useNavigate();
 const handleGitHubLogin = () => {
    window.location.href = `${config.apiBaseUrl}${config.basePath}/auth/github/login`;
    // Replace with prod URL if needed
  };
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    try {
      const resp = await apiRequest<LoginResponse>('/login', {
        method: 'POST',
        body: JSON.stringify({ email, password }),
      });

      localStorage.setItem('authToken', resp.token);
      localStorage.setItem('user', JSON.stringify(resp.user));
      navigate('/dashboard');
    } catch (err: any) {
      setError(err.message || 'Login failed');
    }
  };

  return (
    <div className="centered-page">
      <div className="support-stack">
        <div className="centered-card fade-in">
          <form className="login-form" onSubmit={handleSubmit}>
            <h2>Sign In</h2>
            {error && <p className="error-message">{error}</p>}

            <input
              type="email"
              id="email"
              placeholder="Your email address"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
            />

            <input
              type="password"
              id="password"
              placeholder="Password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
            />

            <button type="submit">Login</button>

            <div className="forgot-password">
              <a href="/forgot-password">Forgot your password?</a>
            </div>
          </form>
        </div>
        <OrDivider />
        <OAuthButton
          label="Sign in with GitHub"
          logo="/github-mark.svg"
          onClick={() => window.location.href = `${config.apiBaseUrl}${config.basePath}/auth/github/login`}
        />
        <OAuthButton
          label="Sign in with Gitea"
          logo="/gitea-svgrepo-com.svg"
          onClick={() => window.location.href = `${config.apiBaseUrl}${config.basePath}/auth/gitea/login`}
        />
        <div className="register-redirect">
          <span>Don’t have an account?</span>
          <a href="/register">Register here</a>
        </div>
      </div>
    </div>

  );
};

export default LoginPage;
